<template>
  <div class="common-header2024 container clearfix">
    <div class="wrapper">
      <div class="logo"></div>
      <div class="edu-name"><img src="~@/assets/images/entry/eduName.png"></div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'CommonHeader',
    props: {
      title: {
        type: String,
        default: ''
      }
    }
  }
</script>
<style lang="scss" scoped>
  .common-header2024 {
    width:100%;
    height:200px;
    background: url("~@/assets/images/entry/header_bg2024.jpg") no-repeat center top;

    .logo {
      width: 151px;
      height: 47px;
      margin-top:41px;
      float: left;
      background: url("~@/assets/images/entry/logo.png") no-repeat;
    }
    .edu-name{
      float:left;
      margin:42px 0 0 33px;
    }
    .title {
      margin-right: 12px;
      width: 395px;
      height: 63px;
      line-height: 63px;
      color: #ffffff;
      text-align: right;
      font-size: 22px;
      float: right;
      background: url("~@/assets/images/entry/right.jpg") no-repeat right bottom;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
</style>
